// Import necessary React hooks and context utilities
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
// Import socket.io-client for real-time communication
import { io } from "socket.io-client";

// Create a React context for chat functionality
const ChatContext = createContext();

// Define the ChatProvider component to manage chat state and socket connection
export const ChatProvider = ({ user, children }) => {
  // Ref to store the socket instance
  const socketRef = useRef(null);
  // State to store chat messages
  const [messages, setMessages] = useState([]);

  // Initialize socket connection when user is available
  useEffect(() => {
    // Exit if no user ID is provided
    if (!user?.id) return;

    // Create socket connection with the server
    socketRef.current = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:3001", {
      query: { user_id: user.id },
    });

    // Listen for new messages from the server
    socketRef.current.on("newMessage", (msg) => {
      setMessages(prev => [...prev, msg]);
    });

    // Cleanup: Disconnect socket when component unmounts
    return () => socketRef.current.disconnect();
  }, [user]);

  // Function to send a message via socket
  const sendMessage = (msg) => {
    socketRef.current.emit("send_message", msg);
    setMessages(prev => [...prev, msg]);
  };

  // Provide chat context to child components
  return (
    <ChatContext.Provider value={{ socketRef, messages, sendMessage }}>
      {children}
    </ChatContext.Provider>
  );
};

// Custom hook to access chat context
export const useChat = () => useContext(ChatContext);